const getters = {
  getInsurancePlan(state) {
    const insuracePlan = Object.keys(state.data.healthInsuranceVariables).length ? state.data.healthInsuranceVariables?.variaveis[state.data.healthInsuranceVariables?.variaveis.length - 1] : null;
    return insuracePlan ? insuracePlan.valores[insuracePlan.valores.length - 1].valor : null;
  },

  getHealthInsuranceState(state) {
    return state;
  }
};

export default getters;
